import { merge, find } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { Component, OnInit, Input, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import {
  SubForma,
  ConfirmComponent,
  BaseControl,
  Option,
  CondicionColumna
} from '@app/shared';
import { CondictionsColumnsTableConfigService } from './shared/condictions-columns-table.config.service';
import { CondictionsColumnsTableFormsService } from './shared/condictions-columns-table.form.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-condictions-columns-table',
  templateUrl: './condictions-columns-table.component.html',
  styleUrls: ['./condictions-columns-table.component.scss'],
  providers: [CondictionsColumnsTableFormsService]
})
export class CondictionsColumnsTableComponent implements OnInit, OnDestroy {

  // Entrada de las condiciones
  @Input() form: SubForma;
  // Mensaje de la accion a realizar en el formulario de condición
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el registro seleccionado
  rowSelect: CondicionColumna;
  // Define cuando se muestra el formulario para agregar o modificar la condicion
  formCondiction = false;
  // Define cuando se modifica la condicion o se agrega una nueva
  condictionEdit = false;
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Opciones con las columnas de la tabla
  optionsColumns: Array<Option> = [];
  // Contiene las condiciones configuradas
  condictions: Array<CondicionColumna> = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') private ngSelectTpl: TemplateRef<any>;

  constructor(private cctfs: CondictionsColumnsTableFormsService, private toastr: ToastrService) { }

  ngOnInit() {
    const configTable = new CondictionsColumnsTableConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.loadingColumnsTable();
    this.loadingCondictionsColumnsTable();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Define las acciones a relaizar en la tabla
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof CondictionsColumnsTableComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.actionForm = 'Agregar';
        this.condictionEdit = false;
        this.controls = this.cctfs.getFormCondiction(this.ngSelectTpl, {'columns': this.optionsColumns});
        this.formCondiction = true;
        break;
      case 'update':
        this.actionForm = 'Modificar';
        this.condictionEdit = true;
        this.controls = this.cctfs.getFormCondiction(this.ngSelectTpl, {'columns': this.optionsColumns}, data);
        this.rowSelect = data;
        this.formCondiction = true;
        break;
      case 'delete':
        this.rowSelect = data;
        this.question = '¿Realmente desea eliminar el registro?';
        this.confirm.open();
        break;
    }
  }

  /**
   * Cierra el formulario de condiciones
   *
   * @memberof CondictionsColumnsTableComponent
   */
  closeFormCondiction() {
    this.actionForm = '';
    this.controls = [];
    this.rowSelect = null;
    this.condictionEdit = false;
    this.formCondiction = false;
  }

  /**
   * Guarda o modifica la condicion con los parametros ingresados en el formulario
   *
   * @param {*} data
   * @memberof CondictionsColumnsTableComponent
   */
  sended(data: any) {
    const columnExist = find(this.condictions, {columna: data.cboColumn, accion: data.cboAction});
    if (
      !columnExist ||
      (this.condictionEdit && this.rowSelect.index === columnExist.index)
    ) {
      const condiction: CondicionColumna = {
        columna: data.cboColumn,
        accion: data.cboAction,
        valor: data.cboValue,
        mensaje: data.txtMessage
      };
      if (
        this.form &&
        this.form.estilo &&
        this.form.estilo['condiciones_columnas'] &&
        this.form.estilo['condiciones_columnas'].length
      ) {
        if (this.condictionEdit) {
          this.form.estilo['condiciones_columnas'][this.rowSelect.index] = condiction;
          this.condictions[this.rowSelect.index] = condiction;
        } else {
          this.form.estilo['condiciones_columnas'].push(condiction);
          this.condictions.push(condiction);
        }
      } else {
        this.form.estilo['condiciones_columnas'] = [condiction];
        this.condictions = [condiction];
      }
      this.closeFormCondiction();
      this.refreshDataTable();
    } else {
      this.toastr.warning('Solo se puede agregar una condición por columna', 'Columna ya condicionada');
    }
  }

  /**
   * Controla la accion en el modal de confirmaciones
   *
   * @param {boolean} resp
   * @memberof CondictionsColumnsTableComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      this.deleteCondiction();
    }
  }

  /**
   * Elimina el registro seleccionado de las condiciones
   *
   * @private
   * @memberof CondictionsColumnsTableComponent
   */
  private deleteCondiction() {
    if (this.rowSelect) {
      if (
        this.form &&
        this.form.estilo &&
        this.form.estilo['condiciones_columnas'] &&
        this.form.estilo['condiciones_columnas'].length
      ) {
        this.form.estilo['condiciones_columnas'].splice(this.rowSelect.index, 1);
        this.condictions.splice(this.rowSelect.index, 1);
        this.refreshDataTable();
      }
    }
  }

  /**
   * Carga las opciones de las columnas para el formulario
   *
   * @private
   * @memberof CondictionsColumnsTableComponent
   */
  private loadingColumnsTable() {
    if (this.form && this.form.campos.length) {
      this.form.campos.forEach(control => {
        if (control.tipo_campo.nombre !== 'label') {
          this.optionsColumns.push(
            {key: control.alias, value: control.alias}
          );
        }
      });
    }
  }

  /**
   * Carga las condiciones configuradas para la tabla
   *
   * @private
   * @memberof CondictionsColumnsTableComponent
   */
  private loadingCondictionsColumnsTable() {
    this.condictions = [];
    if (
      this.form &&
      this.form.estilo &&
      this.form.estilo['condiciones_columnas'] &&
      this.form.estilo['condiciones_columnas'].length
    ) {
      this.form.estilo['condiciones_columnas'].forEach((condiction: CondicionColumna, i: number) => {
        this.condictions.push(merge(condiction, {index: i}));
      });
    }
    this.sourceData = new LocalDataSource(this.condictions);
  }

  /**
   * Refresca la informacion en la tabla
   *
   * @private
   * @memberof CondictionsColumnsTableComponent
   */
  private refreshDataTable() {
    if (this.condictions.length) {
      this.condictions.forEach((condiction, i) => {
        condiction.index = i;
      });
    }
    this.sourceData = new LocalDataSource(this.condictions);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/condictions-columns-table/condictions-columns-table.component.ts